/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const  getLivroSCH= (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  return filtro
}


export const LivroSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
  return filtro
}
